<template>
  <el-container>
    <el-aside width="200px">
      <slot name="tree">
        <el-tree
          ref="tree"
          class="border border-solid px-5"
          :data="tree"
          highlight-current
          node-key="id"
          auto-expand-parent
          :check-on-click-node="true"
          :default-expand-all="true"
          @node-click="handleNodeClick"
        ></el-tree>
      </slot>
    </el-aside>
    <el-container v-if="tree.length">
      <el-main class="space-y-5 relative">
        <slot
          name="tags"
          :list="forms"
          :current-index="currentIndex"
          :index-change="handleIndexChange"
        >
          <div class="flex space-x-5 flex-wrap border-b border-solid pb-2">
            <div>{{ progress }}</div>
            <el-tag
              class="cursor-pointer"
              size="medium"
              v-for="(_, index) in forms"
              :key="index"
              :closable="false"
              :type="getTagType(_)"
              :effect="currentIndex === index ? 'dark' : 'plain'"
              @click="handleIndexChange(index)"
              >{{ _.i }}</el-tag
            >
          </div>
        </slot>
        <slot
          name="default"
          v-bind="{
            list,
            forms,
            currentIndex,
            current,
            currentForm,
            indexChange: handleIndexChange,
            upload: handleUpload,
            down: handleDown,
          }"
        ></slot>

        <el-button
          v-if="info.id"
          class="fixed right-0 top-1/2"
          @click="showDrawer = true"
          >专家评审</el-button
        >

        <el-drawer title="评审意见" :visible.sync="showDrawer">
          <el-container class="h-full">
            <el-main class="h-full">
              <slot
                name="drawer"
                v-bind="{ pivots: currentPivot, current, down: handleDown }"
              ></slot>
            </el-main>
          </el-container>
        </el-drawer>
      </el-main>
    </el-container>
    <el-container v-else class="w-full">
      <el-empty class="w-full" />
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: [
    "list",
    "answers",
    "findAnswer",
    "all",
    "tree",
    "isView",
    "role",
    "info",
    "nodeClick",
  ],
  data() {
    return {
      currentIndex: 0,
      forms: [],
      currentForm: {},
      showDrawer: false,
    };
  },
  computed: {
    ...mapGetters(["token"]),
    current() {
      return this.list[this.currentIndex] || {};
    },
    questionAnswers() {
      return this.list.map((v) =>
        Object.assign({ saved: true, i: v.i }, this.findAnswer(v))
      );
    },
    currentAnswer() {
      return this.questionAnswers[this.currentIndex];
    },
    currentPivot() {
      return this.all.filter(
        (v) =>
          v.quesId === this.currentAnswer.quesId &&
          (this.info.declarationStatus === 0
            ? true
            : v.version * 1 <= this.info.version - 1)
      );
    },
    savedForm() {
      return this.forms.filter((v) => v.id);
    },
    progress() {
      return `已完成: ${this.savedForm.length}/${this.forms.length}`;
    },
  },
  watch: {
    questionAnswers: {
      handler(newVal) {
        this.forms = newVal.map((v) => Object.assign({}, v));
      },
      immediate: true,
    },
    currentAnswer: {
      handler() {
        this.currentForm = this.forms[this.currentIndex] || { saved: true };
      },
      immediate: true,
    },
    current(newVal) {
      this.$refs.tree.setCurrentKey(newVal.id);
    },
  },
  mounted() {
    this.$refs.tree.setCurrentKey(this.current.id);
  },
  methods: {
    getTagType(_) {
      if (this.role !== "enterprise" && this.info.declarationStatus === 0) {
        const answer = this.all.find(
          (v) =>
            v.quesId * 1 === _.quesId * 1 &&
            v.pivot &&
            v.pivot.version * 1 === this.info.version
        );
        return answer
          ? _.changeStatus * 1 === 1
            ? "warning"
            : "success"
          : _.changeStatus * 1 === 1
          ? "warning"
          : "";
      } else {
        const answer = this.all.find(
          (v) =>
            v.quesId * 1 === _.quesId * 1 &&
            v.pivot &&
            v.version * 1 === this.info.version - 1
        );
        return answer
          ? _.status === 0 && answer.pivot.status === 0
            ? "danger"
            : "success"
          : _.id
          ? "success"
          : "";
      }
    },
    handleIndexChange(index) {
      if (!this.currentForm.saved && !this.isView) {
        this.$confirm("未保存数据, 跳转会丢失数据, 是否继续跳转?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.currentIndex = index;
          })
          .catch(() => {});
      } else {
        this.currentIndex = index;
      }
    },
    handleDown(file, noJson = true) {
      fetch(`/dev/minio/${file.id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.token}`,
        },
      })
        .then((res) => res.blob())
        .then((blob) => {
          if (noJson && blob.type === "application/json") {
            return Promise.reject(new Error("server fail"));
          }
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = file.name;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch(() => {
          this.$message.error("下载文件出错,请稍后再试!");
        });
    },
    handleUpload() {
      return new Promise((resolve, reject) => {
        const dom = document.createElement("input");
        dom.type = "file";
        dom.style.display = "none";
        dom.accept = ".doc,.docx,.xls,.xlsx,.pdf,image/*";
        document.body.appendChild(dom);
        dom.addEventListener("change", () => {
          const file = dom.files[0];
          if (file) {
            const formData = new FormData();
            formData.append("file", file);
            fetch("/dev/minio", {
              method: "POST",
              headers: {
                Authorization: `Bearer ${this.token}`,
              },
              body: formData,
            })
              .then((res) => res.json())
              .then((data) => {
                resolve(data.data);
                this.$message.success("上传成功!");
              })
              .catch(() => {
                reject(new Error("upload fail"));
                this.$message.error("上传失败,请稍后再试!");
              });
          }
        });
        dom.click();
      });
    },
    handleNodeClick(node) {
      const index = this.nodeClick(node);
      if (index > -1) {
        this.currentIndex = index;
      }
    },
  },
};
</script>
